import React from 'react';
import PropTypes from 'prop-types';

import Amount from "components/Display/Amount";

import TransactionKey from "../Display/TransactionKey";


class CancellationResultTable extends React.Component {

  constructor(props){
    super(props);
  }

  render() {
    if (!this.props.data.cancellationStatus){
      return (
        <div/>
      );
    }
    let cancellationStatus = this.props.data.cancellationStatus;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="4" className="text-left">
              <span className="calc-setting-table-header">Staða á niðurfellingu miðað við þennnan útreikning.</span>
            </th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Reikningur</th>
            <th className="text-right">Eftirst.</th>
            <th className="text-right">Áður skilað</th>
          </tr>
          </thead>
          <tbody>
          {cancellationStatus.lines.map((item,i) => {
            return(
              <tr key={i}>
                <td className="text-left">{item.cancellationType === 2 ? <span>Kostnaðarhlutdeild kröfuhafa samtals</span>: <TransactionKey data={item.transactionKey}/>}</td>
                <td className="text-right"><Amount data={item.currentAmount}/></td>
                <td className="text-right"><Amount data={item.remainingAmount}/></td>
                <td className="text-right"><Amount data={item.alreadyReturned}/></td>
              </tr>)
          })}
          </tbody>
        </table>
      </div>
    );
  }
}

CancellationResultTable.propTypes = {
  data: PropTypes.object,
};



export default CancellationResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/CancellationResultTable.js